import { Linkedin, Mail, Users, Layers } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0A0A0A] text-white"
        >
            <div className="container-page py-14 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-start">
                    <div className="md:col-span-4">
                        <div className="flex items-center gap-2.5">
                            <div className="w-9 h-9 rounded-lg bg-white flex items-center justify-center">
                                <span className="font-display font-extrabold text-[#0A0A0A] text-sm leading-none">
                                    AV
                                </span>
                            </div>
                            <span className="font-display font-bold text-base">
                                AV Consultation
                            </span>
                        </div>
                        <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-md">
                            An experienced operator helping productivity software founders build an in-house creator engine that compounds long after the engagement ends.
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 font-bold">
                            Explore
                        </p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <Link
                                    to="/hiring"
                                    data-testid="footer-hire-talent"
                                    className="inline-flex items-center gap-2 text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    <Users className="h-4 w-4" />
                                    Hire talent
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/creator-program"
                                    data-testid="footer-omnichannel"
                                    className="inline-flex items-center gap-2 text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    <Layers className="h-4 w-4" />
                                    Go omnichannel
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 font-bold">
                            Connect
                        </p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <a
                                    href="https://www.linkedin.com/posts/ambuj-vats_i-have-been-an-influencer-marketer-for-the-share-7467592145286344704-9Q6n/?utm_source=share&utm_medium=member_desktop&rcm=ACoAADR3F_8BJz2Or9XtHHqQDgA8g0aeih0uifQ"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-linkedin"
                                    className="inline-flex items-center gap-2 text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    <Linkedin className="h-4 w-4" />
                                    LinkedIn
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:ambuj@av-consultation.com"
                                    data-testid="footer-email"
                                    className="inline-flex items-center gap-2 text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    <Mail className="h-4 w-4" />
                                    ambuj@av-consultation.com
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 font-bold">
                            Legal
                        </p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <Link
                                    to="/privacy"
                                    data-testid="footer-privacy"
                                    className="text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/terms"
                                    data-testid="footer-terms"
                                    className="text-white/80 hover:text-[#C6F432] transition-colors"
                                >
                                    Terms &amp; Conditions
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <p
                        data-testid="footer-copyright"
                        className="text-xs text-white/40"
                    >
                        © {year} AV Consultation. All rights reserved.
                    </p>
                    <p className="text-xs text-white/40">
                        Built for founders who want to own their systems.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
